import componentSlider from "../../common/componentSlider.js";
import DOMPurify from "dompurify";

export default () => {
  document.querySelectorAll(".js-slideshow").forEach((el) => {
    if (document.querySelector(".is-page-editor")) {
      return;
    }

    const slides = el.querySelectorAll(".js-slide-container > *");
    const captionContainerEl = el.querySelector(
      ".js-slideshow-caption-container",
    );
    const sliderType = el.dataset.type || "default"; // polaroid or default

    // move captions from slides to caption container
    slides.forEach((slide) => {
      const newCaption = document.createElement("div");
      newCaption.classList.add("image-block__caption", "js-slide-caption");

      const caption = slide.querySelector(".image-block__caption");
      if (caption) {
        newCaption.innerHTML = DOMPurify.sanitize(caption.innerHTML);
      }

      captionContainerEl.appendChild(newCaption);

      const figure = slide.querySelector("figure");
      if (figure) {
        figure.setAttribute("aria-labelledby", newCaption.id);
      }
    });

    const captions = el.querySelectorAll(".js-slide-caption");

    if (captions.length > 0) {
      captions[0].classList.add("is-active");
    }

    if (slides.length < 2) {
      return;
    }

    const slideCounterEl = el.querySelector(".js-slideshow__slide-counter");

    if (slideCounterEl) {
      slideCounterEl.textContent = `1 / ${slides.length}`;
    }

    const config = {
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      speed: 850,
      slidesToShow: 1,
      slidesToScroll: 1,
      accessibility: true,
      autoplay: false,
    };

    if (document.dir === "rtl" || el.parentElement.dir === "rtl") {
      config.rtl = true;
      el.dataset.isRtl = "true";
    }

    if (sliderType === "polaroid") {
      config.slidesToShow = 3;
      config.centerMode = true;
      config.variableWidth = true;
    }

    const { $slider } = componentSlider(el, config);

    $slider.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        captionContainerEl
          .querySelector(".is-active")
          ?.classList.remove("is-active");
        captions[nextSlide].classList.add("is-active");

        if (slideCounterEl) {
          slideCounterEl.textContent = `${nextSlide + 1} / ${slides.length}`;
        }
      },
    );

    $slider.on("afterChange", function (event, slick, currentSlide) {
      setTimeout(function () {
        el.querySelector(".slick-current")?.setAttribute("aria-hidden", false);
      }, 100);
    });

    el.querySelector(".slick-current")?.setAttribute("aria-hidden", false);
  });
};
